import React from 'react'
import ProductList from "../components/ProductList"

import SliderShow from '../components/SliderShow'

const ProductsPage = () => {
  return <div>
     <SliderShow/>
    <ProductList/> 
  </div>
  
}

export default ProductsPage
